import { useState, useEffect } from 'react';
import {
  get as _get,
  range as _range,
  forEach as _forEach,
  isEmpty as _isEmpty,
  remove as _remove,
} from 'lodash';

import { ODDS_PANEL_MARKETS_NUMBER } from 'constants/app';

const useBSOdds = (marketsOutcomesArr, marketsNameShortArr) => {
  const [usedMarket, setUsedMarket] = useState(null);
  const [usedMarket2, setUsedMarket2] = useState(null);

  const [usedMarketTbids, setUsedMarketTbids] = useState([]);
  const [usedMarket2Tbids, setUsedMarket2Tbids] = useState([]);


  useEffect(() => {
    try {
      const createMarket = idx => ({
        outcomes: marketsOutcomesArr[idx],
        marketName: marketsNameShortArr[idx],
        betstop: marketsOutcomesArr[idx].some(outcome => outcome.betstop),
      });

      const oddsKeysToRemove = [];

      // Collect all odds keys with closed markets to keep valid KEYS IDS
      _forEach(marketsOutcomesArr, (odds, oddsKey) => {
        if (odds.some(outcome => outcome.betstop)) {
          oddsKeysToRemove.push(oddsKey);
        }
      });

      const removeKeyFn = (oddConfiguration, key) => {
        if (oddsKeysToRemove.includes(key)) {
          return true;
        }

        return false;
      };

      // Remove blocked markets
      _remove(marketsOutcomesArr, removeKeyFn);
      _remove(marketsNameShortArr, removeKeyFn);

      // Available 2 markets to display in BS
      if (_isEmpty(marketsOutcomesArr)) {
        setUsedMarket(null);
        setUsedMarket2(null);
        setUsedMarketTbids([]);
        setUsedMarket2Tbids([]);
        return;
      }

      // Store market positions
      let marketOddsKeys = [];

      if (marketsOutcomesArr.length >= ODDS_PANEL_MARKETS_NUMBER + 2) {
        // 6+ markets available
        // Take the first 2 from the range (ODDS_PANEL_MARKETS_NUMBER .. end)
        const deterministicRange = _range(ODDS_PANEL_MARKETS_NUMBER, marketsOutcomesArr.length);
        marketOddsKeys = deterministicRange.slice(0, 2);
      } else if (marketsOutcomesArr.length > ODDS_PANEL_MARKETS_NUMBER + 1) {
        // Exactly 5 markets available
        // Take first element from first 4 markets (0..3)
        marketOddsKeys = [0]; // instead of a random one

        // Add market at position ODDS_PANEL_MARKETS_NUMBER (5th market)
        marketOddsKeys.push(ODDS_PANEL_MARKETS_NUMBER);
      } else {
        // Max 2 markets from position 0..length-1
        const deterministicRange = _range(0, marketsOutcomesArr.length);
        marketOddsKeys = deterministicRange.slice(0, 2);
      }

      // At least one market should be always available
      const firstIdx = marketOddsKeys[0];
      const market1 = createMarket(firstIdx);

      setUsedMarket(market1);
      setUsedMarketTbids(market1.outcomes.map(o => o.tbid));

      // Try to get 2nd element from BS array keys
      const secondIdx = _get(marketOddsKeys, 1, null);

      if (secondIdx !== null && secondIdx !== undefined) {
        const market2 = createMarket(secondIdx);

        setUsedMarket2(market2);
        setUsedMarket2Tbids(market2.outcomes.map(o => o.tbid));
      } else {
        setUsedMarket2(null);
        setUsedMarket2Tbids([]);
      }
    } catch (e) {
      setUsedMarket(null);
      setUsedMarket2(null);
      setUsedMarketTbids([]);
      setUsedMarket2Tbids([]);
    }
  }, [marketsNameShortArr, marketsOutcomesArr]);

  return {
    usedMarket,
    usedMarket2,
    usedMarketTbids,
    usedMarket2Tbids,
  };
};

export default useBSOdds;
